import { createRouter, createWebHashHistory } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useBuyerStore } from '@/stores/BuyerStore'

const routes = [
    {
      path: "/",
      component: () => import("@components/Company.vue"),
      children: [        
        {
          path: "",
          name: "profile",
          component: () => import("@components/buyerComponents/BuyerProfile.vue"),          
        },
        {
          path: "edit",
          name: "profile-edit",
          component: () => import("@components/buyerComponents/BuyerProfileEdit.vue"),          
        },        
        {
          path: "login",
          name: "login",
          component: () => import("@components/buyerComponents/BuyerLogin.vue"),
        },        
        {
          path: "forgot-password",
          name: "forgot-password",
          component: () => import("@components/buyerComponents/BuyerForgotPassword.vue"),
        },        
        {
          path: "reset-password/:token",
          name: "reset-password",
          component: () => import("@components/buyerComponents/BuyerResetPassword.vue"),
        },        
      ],
    },
    
    // Always leave this as last one,
    // but you can also remove it
    {
      path: "/:catchAll(.*)*",
      component: () => import("@components/404.vue"),
    },
  ];

  const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHashHistory(),
    routes, // short for `routes: routes`
  })

  router.beforeEach(async (to, from, next) => {
    if(to.name == 'forgot-password' || to.name == 'reset-password') {
        next();
    }
    const buyerStore = useBuyerStore()
    await buyerStore.getProfile()
    const { authenticated } = storeToRefs(buyerStore)
    if(!authenticated.value && to.name != 'login') {
      next({ name: 'login'})
    } else {
      next()
    }
  })
  
  export default router;
  